import React, { useMemo } from 'react';

import PageHeader from '@shared/PageHeader';
import MerchantSelect from '@components/operator/MerchantSelect';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import StockTransferOrderForm from './components/StockTransferOrderForm';

interface InventoryTypeOption {
  id: string;
  code?: string;
  name: string;
  [key: string]: unknown;
}

interface MerchantInventoryType {
  merchant_id: string;
  enabled?: boolean;
  inventory_type: InventoryTypeOption;
}

const StockTransferOrderNew: React.FC = () => {
  const { merchantInventoryTypes } = useOperatorData();

  return (
    <MerchantSelect>
      {({ merchantId }: { merchantId: string }) => (
        <NewBody
          merchantId={merchantId}
          merchantInventoryTypes={merchantInventoryTypes as MerchantInventoryType[] | undefined}
        />
      )}
    </MerchantSelect>
  );
};

interface NewBodyProps {
  merchantId: string;
  merchantInventoryTypes?: MerchantInventoryType[];
}

const NewBody: React.FC<NewBodyProps> = ({ merchantId, merchantInventoryTypes }) => {
  // Reference data 必須跟著當前 MerchantSelect 選到的 merchant 走；新建模式下尚無 record，
  // 不需要 useRecordMerchantSync。
  const inventoryTypes = useMemo<InventoryTypeOption[]>(() => {
    if (!merchantId) return [];
    return (merchantInventoryTypes ?? [])
      .filter(mit => mit.merchant_id === merchantId && mit.enabled !== false)
      .map(mit => mit.inventory_type);
  }, [merchantInventoryTypes, merchantId]);

  return (
    <div>
      <PageHeader items={['stock_transfer_orders', 'stock_transfer_orders.list', 'stock_transfer_orders.new']} />
      <StockTransferOrderForm
        merchantId={merchantId}
        inventoryTypes={inventoryTypes}
      />
    </div>
  );
};

export default StockTransferOrderNew;
